<template>
  <tr class="marketing-plan-table-item">
    <td>
      <v-checkbox v-if="!manage"
                  v-model="isActive"
                  :ripple="false"
                  hide-details
                  @change="emitChange"></v-checkbox>
    </td>

    <td>
      {{ planItem.name }}
    </td>

    <td>
      {{ planItem.smsAmount }}
    </td>

    <td>
      {{ planItem.emailAmount }}
    </td>

    <!-- <td>
      {{ planItem.whatsappAmount }}
    </td> -->

    <td class="marketing-plan-table-item-actions">
      <template v-if="manage">
        <i class="marketing-plan-table-item-actions-item mdi mdi-square-edit-outline pointer"
           v-tooltip="'Editar'"
           @click="openEditModal"></i>
        <i class="marketing-plan-table-item-actions-item mdi mdi-close pointer"
           v-tooltip="`Deletar`"
           @click="openDeleteModal"></i>
      </template>
    </td>

    <marketing-plan-add-form v-model="showEditForm"
                             :item="planItem"
                             @edited="onEdited" />

    <confirmation-modal :value="showingDeleteConfirmModal"
                        confirm-label="Confirmar"
                        @confirm="deletePlan"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        Deletar Plano?
      </span>
      <span>
        Quer mesmo deletar este plano? Esta ação é irreversível
      </span>
    </confirmation-modal>
  </tr>
</template>

<script>
import EventBus from "@packages/event-bus";
import ConfirmationModal from "@components/ConfirmationModal";
import MarketingPlanAddForm from "@components/modules/marketing/plan/add/form/MarketingPlanAddForm";

export default {
  components: {
    MarketingPlanAddForm,
    ConfirmationModal,
  },

  data() {
    return {
      isActive: false,
      showEditForm: false,
      showingDeleteConfirmModal: false,
    };
  },
  props: {
    planItem: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: false,
    },
    manage: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.isActive = this.planItem.id === this.value;
    },
  },
  methods: {
    onEdited() {
      this.hideEditModal();
      this.emitEdited();
    },
    hideEditModal() {
      this.showEditForm = false;
    },
    emitEdited() {
      this.$emit("edited");
    },
    openEditModal() {
      this.showEditForm = true;
    },
    emitChange() {
      this.$emit("change", {
        selected: this.isActive,
        id: this.planItem.id,
      });
    },
    closeDeleteModal() {
      this.showingDeleteConfirmModal = false;
    },
    openDeleteModal() {
      this.showingDeleteConfirmModal = true;
    },
    async deletePlan() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.marketing.plan.delete({
          planId: this.planItem.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Plano deletado com sucesso!",
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-plan-table-item {
  .marketing-plan-table-item-actions {
    display: flex;
    align-items: center;

    .marketing-plan-table-item-actions-item {
      margin-right: 5px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
